"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgRedo = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M16.538 8.071C15.734 7.165 14.23 5.998 12 5.996 8.87 5.993 6.006 8.48 6 12c-.006 3.52 2.919 6 6 6 0 0 1 0 1 1s-1 1-1 1a8 8 0 116.073-13.208V5a1 1 0 112 0v4.071a1 1 0 01-1 1H15a1 1 0 110-2h1.538z' }))); };
exports.default = SvgRedo;
//# sourceMappingURL=Redo.js.map